import ServiceCreate from "../components/ServiceCreate";
import {connect} from "react-redux";
import {createService} from "../actions/serviceActions";
import isFunc from 'lodash/isFunction';
import {showSnackbar} from "../actions/snachbarActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_SERVICE_CREATE} from "../actions";
import {push} from "react-router-redux";
import {makeRoute, ROUTE_SERVICE_DETAIL} from "../routes";

const m2s = (state, props) => {
	return {
		isLoading: isProcessing(state, PROC_SERVICE_CREATE)
	};
};
const m2d = (dispatch, props) => {
	return {
		onCreate: (service, onSuccess) => dispatch(createService(service, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service.created'));
			dispatch(push(makeRoute(ROUTE_SERVICE_DETAIL, {service_id: result.service.service_id})));
		})),
		push: to => dispatch(push(to))
	};
};

export default connect(m2s, m2d)(ServiceCreate);


// WEBPACK FOOTER //
// ./src/containers/ServiceCreateController.js